import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CnLogo } from '../../assets/images/logo/logo_nooklink_cn.svg';
import { ReactComponent as EnLogo } from '../../assets/images/logo/logo_nooklink_en.svg';
import { ReactComponent as JaLogo } from '../../assets/images/logo/logo_nooklink_ja.svg';
import { ReactComponent as KoLogo } from '../../assets/images/logo/logo_nooklink_ko.svg';
import { ReactComponent as TwLogo } from '../../assets/images/logo/logo_nooklink_tw.svg';

export const Logo: React.FC<{ scale?: number }> = ({ scale }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation('translation');
  const s = scale || 1.0;
  switch (i18n.language) {
    case 'ja-JP':
      return (
        <div style={{ width: `${168 * s}px` }}>
          <JaLogo role="img" aria-label={t('service_name')} />
        </div>
      );
    case 'zh-CN':
      return (
        <div style={{ width: `${176 * s}px` }}>
          <CnLogo role="img" aria-label={t('service_name')} />
        </div>
      );
    case 'zh-TW':
      return (
        <div style={{ width: `${176 * s}px` }}>
          <TwLogo role="img" aria-label={t('service_name')} />
        </div>
      );
    case 'ko-KR':
      return (
        <div style={{ width: `${132 * s}px` }}>
          <KoLogo role="img" aria-label={t('service_name')} />
        </div>
      );
    default:
      return (
        <div style={{ width: `${164 * s}px` }}>
          <EnLogo role="img" aria-label={t('service_name')} />
        </div>
      );
  }
};
